(function () {
    'use strict';
    var controllerId = 'OrderPackageListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', 'NgTableParams', OrderPackageListCtrl]);

    function OrderPackageListCtrl(common, datacontext, $scope, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.startSearch = 0;
        vm.orders = [];
        vm.title = 'Order Package List View';
        vm.query = {
            queryType:'array-count',
            search: "",
            store_id: "",
            pickpack_status_id:"",
            financial_status_id: "4",
            fulfillment_status_id: "1",
            cancel_reason_id: "",
            order_status_id: "1",
            warehouse_id: "",
            ship_method_id:"",
            order_package_status_id:"1,2,3",
            order_package_type_id:"",
            order_age: "+3",
            order_by: "ordered_on",
            order_dir: "asc",
            page: 1,
            limit: 20
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            //console.log("k", i);
            //console.log("v", vm.urlQuery[i]);
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {
        	/*if(vm.grid !== 0){
        		vm.grid = 0;
        		return "";
        	}*/
        	for ( var i in newValue ) {
                if ( i !== 'page' &&  newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true || oldValue[i] < 0 ){
                    	get_order_packages();
                    }else{
                        return "";
                    }

                }
            }

        });

        activate();

        function activate() {
            var promises = [
                get_order_packages(),
                get_stores(),
                get_order_status(),
                get_ship_methods(),
                get_fulfillment_status(),
                get_financial_status(),
                get_fulfillment_warehouses(),
                get_order_package_types(),
                get_order_package_status(),
                get_pickpack_status(),
                get_pickpack_types()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //  log('Activated Order List View');
                });
        }

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }

        function get_pickpack_status() {
            return datacontext.get_pickpack_status().then(function(httpResult) {
                vm.pickpack_status = httpResult.data.data;
            });
        }

        function get_pickpack_types() {
            return datacontext.get_pickpack_types().then(function(httpResult) {
                vm.pickpack_types = httpResult.data.data;
            });
        }

        function get_order_package_types() {
            return datacontext.get_order_package_types().then(function(response) {
                vm.order_package_types = response.data.data;
            });
        }

        function get_order_package_status() {
            return datacontext.get_order_package_status().then(function(response) {
                vm.order_package_status = response.data.data;
            });
        }

        function get_ship_methods() {
            return datacontext.get_ship_methods().then(function(httpResult) {
                vm.ship_methods = httpResult.data.data;
            });
        }

        function get_order_status() {
            return datacontext.get_order_status().then(function (httpResult) {
                vm.order_status_list = httpResult.data.data;
            });
        }

        function get_fulfillment_status() {
            return datacontext.get_fulfillment_status().then(function (httpResult) {
                vm.fulfillment_status_list = httpResult.data.data;
            });
        }

        function get_financial_status() {
            return datacontext.get_financial_status().then(function (httpResult) {
                vm.financial_status_list = httpResult.data.data;
            });
        }

        function get_fulfillment_warehouses() {
            return datacontext.get_warehouses().then(function (httpResult) {
                vm.fulfillment_warehouse_list = httpResult.data.data;
            });
        }

        function get_order_packages() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }

                    // ajax request to api
                    return datacontext.get_order_packages(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }
    }
})();
(function() {
    'use strict';
    var controllerId = 'orderPackagesCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope','$modal', '$routeParams', '$cookies', 'ngDialog', orderPackagesCtrl]);

    function orderPackagesCtrl(common, datacontext, $scope, $modal, $routeParams, $cookies, ngDialog) {
        var getLogFn = common.logger.getLogFn;
        var vm = this;
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        $scope.order_id = $routeParams.oid;
        $scope.label_host = '//s3.amazonaws.com/gco_bucket/shiplabels/';
        $scope.msc = {
            isLoading:0
        };
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
        }
        $scope.$on('refreshOrderPackagesCtrl', function (event, data) {
            activate();
        });

        $scope.upd_pack_detail_check = 0;
        $scope.upd_pack_detail = 1;

        activate();

        function activate() {
            var promises = [
                getOrderPackageFull(),
                getOrderProductSet()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Order List View');
                });
        }

        /*$scope.is_checked = function(upd_pack) {
            console.log(upd_pack);
            if ( upd_pack == 1 || upd_pack === true) {
                $scope.upd_pack_detail_check = 1;
            } else{
                $scope.upd_pack_detail_check = 0;
            }
            console.log($scope.upd_pack_detail_check);
        }*/

        $scope.is_checked = function(upd_pack_detail) {
            console.log(upd_pack_detail);
            if ( upd_pack_detail == 1 || upd_pack_detail === true) {
                $scope.upd_pack_detail = 1;
            } else{
                $scope.upd_pack_detail = 0;
            }
            console.log($scope.upd_pack_detail);
        }

        function getOrderPackageFull() {
            return datacontext.getOrderPackageFull({order_id:$scope.order_id}).then(function(httpResult) {
              console.log(httpResult);
              $scope.order_packages = httpResult.data.data;
              if(angular.isDefined(httpResult.data.data[0])){
                $scope.combined_custmer_orders = httpResult.data.data[0].combined_orders;
                console.log($scope.combined_custmer_orders);
              }

              $scope.order_package_order_status = httpResult.data.ORDER_STATUS;
              $scope.order_packages_cnt = httpResult.data.TOTAL;
            });
        }

        function getOrderProductSet() {
            return datacontext.getOrderProductSet({order_id:$scope.order_id}).then(function(httpResult) {
                console.log(httpResult);
                console.log(httpResult.data);

                $scope.order_product_set_detail = httpResult.data;
            });
        }

        $scope.CreatePackage = function (order_id){
          datacontext.createPackage({order_id:order_id}).then(function(httpResult) {
            getOrderPackageFull();
          });
        };
        $scope.abs_override_upd = function (abs_override,order_package_id,order_id){
          console.log("abs_override"+abs_override);
          if(abs_override === true){
            datacontext.updatePackageABS({order_package_id:order_package_id, abs_override: abs_override, order_id: order_id}).then(function(httpResult) {
              getOrderPackageFull();
            });
          }else{
            datacontext.updatePackageABS({order_package_id:order_package_id, abs_override: abs_override,order_id: order_id}).then(function(httpResult) {
              getOrderPackageFull();
            });

          }
        };

        $scope.alert_packupdate = function (order_package_id,order_id){
            datacontext.alertpackupdate({order_package_id:order_package_id, order_id: order_id}).then(function(httpResult) {
                getOrderPackageFull();
            });
        }

        $scope.open_tracking_label = function (id,ship_courier,order_id,ship_method_id,ship_method,order_package_id,order_note,abs_override,label_type) {
            $scope.tracking_number = id;
            $scope.ship_courier = ship_courier;
            $scope.ship_method_id = ship_method_id;
            $scope.ship_method = ship_method;
            $scope.order_id = order_id;
            $scope.abs_override = abs_override;
            $scope.label_type = label_type;
            console.log(order_note);
            console.log(abs_override);

            if(ship_method_id === 4){
            	datacontext.getOrderPrintFull({order_id:order_id,order_package_id:order_package_id}).then(function(httpResult) {
                    $scope.ship_details = httpResult.data.data;
                    console.log(httpResult.data.data);
                    $scope.abs_override= $scope.ship_details[0].abs_override;
                    $scope.first_name = $scope.ship_details[0].first_name;
                    $scope.last_name = $scope.ship_details[0].last_name;
                    $scope.address_1 = $scope.ship_details[0].address_1;
                    $scope.address_2 = $scope.ship_details[0].address_2;
                    //$scope.address_3 = $scope.ship_details[0].address_3;
                    $scope.city = $scope.ship_details[0].city;
                    $scope.province_code = $scope.ship_details[0].province_code;
                    $scope.ship_courier  = $scope.ship_details[0].ship_courier ;
                    $scope.ship_method  = $scope.ship_details[0].ship_method ;
                    $scope.ship_service_level  = $scope.ship_details[0].ship_service_level ;
                    $scope.order_id  = $scope.ship_details[0].order_id ;
                    $scope.label_type  = $scope.ship_details[0].label_type;
                    $scope.order_package_id  = $scope.ship_details[0].order_package_id ;
                    $scope.ship_method_id = ship_method_id;
                    $scope.marketplace_order_id = $scope.ship_details[0].marketplace_order_id;
                    $scope.total_qty_count = $scope.ship_details[0].total_qty_count ;
                    $scope.store_name = $scope.ship_details[0].store_name;
                    $scope.pickpack_slip_id = $scope.ship_details[0].pickpack_slip_id;
                    $scope.order_note = $scope.ship_details[0].order_note;
                    // $scope.product_title = ;
                    // $scope.category_name = ;
                    // $scope.width_height = ;

                    // create barcode
                    datacontext.createBarCode({label: order_id}).then(function() {
                    	$scope.random = Math.floor((Math.random()*6)+1);
                    });

                    console.log($scope.abs_override);

                    ngDialog.open({
                        template: 'app/orderpackages/ship_label.html',
                        scope: $scope
                    });
                    setTimeout(function () {
                      $('.ship_label_jquery_1').click();
                    }, 2000);
                });
            }else{
                if(order_note.indexOf("Liberty API") !== -1){
                    console.log('123');

                    $scope.liberty = 1;
                    ngDialog.open({
                        template: 'app/orderpackages/ship_label.html',
                        scope: $scope
                    });
                } else if(order_id === 4884897) {
                    console.log('Testing Rebelution 123');

                    ngDialog.open({
                        template: 'tasks/rebelution_label.cfm?tracking=' + $scope.tracking_number,
                        scope: $scope
                    });

                    /* 
                    //This is working our to open the pdf in new tab and print
                    const pdfUrl = 'tasks/rebelution_label.cfm?tracking=' + $scope.tracking_number;
                    const pdfWindow = window.open(pdfUrl, '_blank');

                    if (pdfWindow) {
                        pdfWindow.onload = function () {
                            setTimeout(() => {
                                pdfWindow.print();
                            }, 1500);
                        };
                    }
                    */

                } else{
                    console.log('1234');
                    
                    $scope.liberty = 0;
                    
                    console.log(abs_override);
                    console.log(ship_method_id);
                    console.log(ship_courier);
                    console.log(label_type);
                    console.log(id);

                    ngDialog.open({
                        template: 'app/orderpackages/ship_label.html',
                        scope: $scope
                    });
                }
              setTimeout(function () {
                $('.ship_label_jquery_1').click();
              }, 2000);
            }
        };

        $scope.createPickpackSlipModal = function (pick_pack_type_id,order_id,store_id) {

            $scope.pick_slip_create = {
                pick_pack_type_id: pick_pack_type_id,
                order_id: order_id,
                store_id: store_id,
                from_order: 1
            };
            //console.log($scope.pick_slip_create);
            //$scope.pickpack_slip.pickpack_type_id = pick_pack_type_id;
            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpack_create_modal.html',
                controller:"pickslipCreateModalCtrl",
                windowClass:'small',
                resolve: {
                    pick_slip_create: function () {
                        return $scope.pick_slip_create;
                    }
                }
            }).result.then(function(pickpack_slip_id){
              // create poi
              getOrderPackageFull();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.createWholesalePickpackSlipModal = function (pick_pack_type_id,order_id,store_id) {
            $scope.pick_slip_create = {
                pick_pack_type_id: pick_pack_type_id,
                order_id: order_id,
                store_id: store_id,
                from_order: 1
            };

            console.log($scope.pick_slip_create);
            console.log(order_id);
            
            // merge order item w/order items
            var modalInstance = $modal.open({
                templateUrl: '/app/pickpack/partials/pickpack_create_modal.html',
                controller:"pickslipCreateModalCtrl",
                windowClass:'small',
                resolve: {
                    pick_slip_create: function () {
                        return $scope.pick_slip_create;
                    }
                }
            }).result.then(function(pickpack_slip_id){
                // create poi
                getOrderPackageFull();
            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };


        //create new shipping label
        $scope.create_tracking_label = function (data) {
        	console.log(data);
        	vm.submitted = true;

            if ( angular.isDefined(data.upd_pack_detail) && data.upd_pack_detail == 1 || data.upd_pack_detail === true) {
                $scope.upd_pack_detail = 1;
            } else{
                $scope.upd_pack_detail = 0;
            }

          if(data.ship_method_id === 21 || data.ship_method_id === 32 || data.abs_override === 1){
            console.log(data);
            if(data.abs_override === 1){
              data.is_prime = 1;
            }
            
            if(data.ship_method_id === 32){
              data.is_prime = 1;
            }
            $scope.label_values = {order_id:data.order_id,is_prime: data.is_prime,order_package_id:data.order_package_id};

            var modalInstance = $modal.open({
                templateUrl: '/app/orderpackages/sfp_label_create.html',
                controller: 'onSFPLabelModalCtrl',
                resolve: {
                    label_values: function () {
                        return $scope.label_values;
                    }
                }
            }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };

          }else if(data.ship_method_id === 7) {

            console.log(data); 
            $scope.label_values = {
                    order_id: data.order_id, 
                    is_prime: data.is_prime, 
                    order_package_id: data.order_package_id, 
                    ship_to_address_id: data.ship_address_id, 
                    ship_method_id: data.ship_method_id, 
                    fulfillment_warehouse_id: data.fulfillment_warehouse_id, 
                    customer_id: data.customer_id, 
                    label_ready: data.label_ready, 
                    upd_pack_detail: $scope.upd_pack_detail,
                    pickpack_slip_id: data.pickpack_slip_id,
                    items_packed: data.items
            };

            console.log('Testing-Yamuna');
            console.log($scope.label_values);

            var modalInstance = $modal.open({
                templateUrl: '/app/orderpackages/fedex_ground_label_create.html',
                controller: 'onFEDEXGroundLabelModalCtrl',
                resolve: {
                    label_values: function () {
                        return $scope.label_values;
                    }
                }
            }).result.then(function(result){

            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            }

          } else{
            if(data.ship_method_id === 27 && data.order_ids.length) {
                var shipLabelRequest = {
                    order_id:data.order_id,
                    order_package_id:data.order_package_id,
                    ship_to_address_id:data.ship_address_id,
                    ship_method_id:data.ship_method_id,
                    fulfillment_warehouse_id:data.fulfillment_warehouse_id,
                    customer_id:data.customer_id,
                    label_ready:data.label_ready,
                    upd_pack_detail:$scope.upd_pack_detail,
                    order_ids:data.order_ids
                };    
            } else {
                var shipLabelRequest = {
                    order_id:data.order_id,
                    order_package_id:data.order_package_id,
                    ship_to_address_id:data.ship_address_id,
                    ship_method_id:data.ship_method_id,
                    fulfillment_warehouse_id:data.fulfillment_warehouse_id,
                    customer_id:data.customer_id,
                    label_ready:data.label_ready,
                    upd_pack_detail:$scope.upd_pack_detail,
                    order_ids:""
                };
            }
            
            console.log(shipLabelRequest);

            var fulfillment_status_id = "";
            var order_id = data.order_id;
            var pickpack_slip_id = data.pickpack_slip_id;
            var items_packed = data.items;
            var arrayLength = items_packed.length;
            // check if last item and mark slip as done

            // Loop items and mark as packed
            var qty_ordered = 0;
            var qty_packed = 0;
            var update_success = true;

          	datacontext.createShipLabel(shipLabelRequest).success(function(httpResult) {

                console.log(shipLabelRequest);

                  if (httpResult.success === true) {

                        // Push to page
                        console.log(httpResult);

                        // UPDATE QTY PICKED AND TRACKING NUMBER
                        for (var i = 0; i < arrayLength; i++) {
                            // add pickpack/order id to item array
                            items_packed[i].pickpack_slip_id = pickpack_slip_id;
                            items_packed[i].order_id = order_id;
                            items_packed[i].order_package_id = $scope.order_package_id;
                            items_packed[i].package_item_id = items_packed[i].package_item_id;
                            // sum up ordered
                            qty_ordered = items_packed[i].to_ship_qty;
                            // sum up packed
                            items_packed[i].qty_packed = items_packed[i].to_ship_qty;
                            items_packed[i].order_package_id = data.order_package_id;
                            items_packed[i].only_packing = 1;
                            items_packed[i].from_od_page = 1;
                            items_packed[i].upd_pack_detail = httpResult.UPD_PACK_DETAIL;
                            // Update QTY Packed
                            datacontext.update_pack_list(items_packed[i]).success(function(rSPQ) {
                                // Returns list of Pick / Pack slips
                                if (rSPQ.SUCCESS === true) {
                                    console.log('updated');
                                } else {
                                    console.log('not updated');
                                }
                            });
                        }

                        window.location.reload();  
                      
                } else {
                  	console.log(httpResult);
                    /*console.log(data.ship_method_id);
                    console.log(data.store_id);
                    console.log(data.order_id);

                    if(data.ship_method_id === 16 && (data.store_id === 1 || data.store_id === 9) && data.order_id === '2872113'){
                        var itemData = {
                            order_package_id:data.order_package_id,
                            abs_override: 1,
                            order_id:data.order_id,
                            from_pack_audit:1
                        };
                        datacontext.updatePackageABS(itemData).success(function(httpResult) {
                            location.reload();
                        });
                    }*/

                    if(angular.isDefined(httpResult.data)){
                      $scope.label_error= httpResult.data;
                      log_error(httpResult.data);
                    }
                  	//window.location.reload();
                  }
              });
          }

        }

        $scope.edit_package_modal = function (data) {
            // merge order item w/order items
            $scope.orderpackage = data;

            var modalInstance = $modal.open({
                templateUrl: '/app/orderpackages/edit_package.html',
                controller: 'editPackageModalCtrl',
                resolve: {
                    orderpackage: function () {
                        return $scope.orderpackage;
                    }
                }
            }).result.then(function(result){
                    getOrderPackageFull();
                    $scope.tracking_number = result;

                    setTimeout(function(){
                        window.location.reload();
                    },1000);
                });

            $scope.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.msc.isLoading = 0;
        $scope.push_tracking_details = function (data) {

            var order_id = data;
            $scope.msc.isLoading = 1;
            //console.log(order_id);

            return datacontext.push_jet_tracking_details({"order_id":order_id}).then(function(httpResult) {

                $scope.msc.isLoading = 0;

                if(httpResult.data == 1){
                    log_success('Tracking Details Sent');
                }else{
                    log_error('Error Occured');
                }
                //console.log(httpResult);
            });

        };

        $scope.reprint_wfp_ftp = function (layout,order_package_id,to_ship_qty,product_id,category_id,pod_dimension_id,master_product_id,order_id,pickpack_slip_id,width,height,user_orientation_id,hi_res_image_id,wfp_image_s3_status) {

            var itemDataNew = {
                  product_id: product_id,
                  master_product_id: master_product_id};
            if(wfp_image_s3_status !== 1){
            datacontext.check_wfp_image(itemDataNew).success(function(httpResult) {
              var error_message = httpResult;

                if(pod_dimension_id === 8){
                	var layout = 0;
                	
                    if(user_orientation_id = 3){
                        layout = 0;
                    }else if(user_orientation_id = 4){
                        layout = 1;
                    };

                };

              $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,pod_dimension_id:pod_dimension_id,master_product_id:master_product_id,
                                    order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,hi_res_image_id:hi_res_image_id};

              var modalInstance = $modal.open({
                  templateUrl: '/app/orderpackages/reprint_wfp_ftp_modal.html',
                  controller: 'onRePrintWfpFtpModalCtrl',
                  resolve: {
                      print_values: function () {
                          return $scope.print_values;
                      }
                  }
              }).result.then(function(result){
                      //$scope.tracking_number = result;
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };
            });
          }else{
            var error_message = "";

            if(pod_dimension_id === 8){
            	var layout = 0;

                if(user_orientation_id = 3){
                    layout = 0;
                }else if(user_orientation_id = 4){
                    layout = 1;
                };

            };

            $scope.print_values = {layout:layout,order_package_id:order_package_id,to_ship_qty:to_ship_qty,product_id:product_id,category_id:category_id,pod_dimension_id:pod_dimension_id,master_product_id:master_product_id,
                                  order_id:order_id,pickpack_slip_id:pickpack_slip_id,error_message:error_message,width:width,height:height, user_orientation_id:user_orientation_id,hi_res_image_id:hi_res_image_id};

            var modalInstance = $modal.open({
                templateUrl: '/app/orderpackages/reprint_wfp_ftp_modal.html',
                controller: 'onRePrintWfpFtpModalCtrl',
                resolve: {
                    print_values: function () {
                        return $scope.print_values;
                    }
                }
            }).result.then(function(result){
                    //$scope.tracking_number = result;
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
          }
        };

        $scope.repick = function (order_package_id,order_id,pickpack_slip_id) {

            var itemDataNew = {
                  order_package_id: order_package_id,
                  order_id: order_id};

            datacontext.get_package_items(itemDataNew).success(function(httpResult) {
              $scope.repick_print = httpResult.data;
              $scope.user_name = httpResult.USER_NAME;

              var modalInstance = $modal.open({
                  templateUrl: '/app/orderpackages/repick_modal.html',
                  controller: 'onRePickModalCtrl',
                  resolve: {
                      repick_print: function () {
                          return $scope.repick_print;
                      },
                      user_name: function() { return $scope.user_name; }
                  }
              }).result.then(function(result){
                      //$scope.tracking_number = result;
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };
            });

        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'onSFPLabelModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','label_values', onSFPLabelModalCtrl]);

    function onSFPLabelModalCtrl(common, datacontext, $scope, $modalInstance, label_values) {

        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.order_id = label_values.order_id;
        $scope.is_prime = label_values.is_prime;
        $scope.order_package_id = label_values.order_package_id;
        $scope.isDisabled = true;
        $scope.fedEx_lowestFound = 0;

        //$scope.printer = 4;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.checkShipRate = function(packshipssel){
            var packshipssel = packshipssel;
            var shipprice = packshipssel.split('|')[1];

            if( shipprice <= 25){
                $scope.isDisabled = false;
            }else{
                $scope.isDisabled = true;
            }
        };

        
        //$scope.selectPackageType($scope.packshippackage,$scope.order_id,1,1,0,0);

        $scope.selectPackageType = function(packshippackage,order_id,multi,is_prime) {
            //console.log(packshippackage);
            //console.log(order_id);
            if(is_prime === 1){
        return datacontext.getEligibleShips({
            order_id: order_id,
            packshippackage: packshippackage,
            multi: multi
        }).then(function(httpResult) {

            // if($scope.is_prime === 1){
            //     return datacontext.getEligibleShips({order_id:$scope.order_id,packshippackage:$scope.packshippackage,multi:1}).then(function(httpResult) {
                    vm.loading = false;

                    console.log(httpResult);

                    console.log(httpResult.data.SHIPS);

                    $scope.LOWESTSERVICEID = httpResult.data.LOWESTSERVICEID;
                    if($scope.LOWESTSERVICEID === 'FEDEX_PTP_EXPRESS_SAVER_ONE_RATE'){
                        log_error('shipment is "FedEx OneRate"');
                    }else if(angular.isDefined(httpResult.data.ERROR) && httpResult.data.ERROR.length > 1){
                        log_error(httpResult.data.ERROR);
                    }

                    $scope.LOWESTSHIPCOST = httpResult.data.LOWESTSHIPCOST;
                    //console.log($scope.LOWESTSHIPCOST);

                    $scope.weight = httpResult.data.WEIGHT;
                    $scope.length = httpResult.data.LENGTH;
                    $scope.packshipssel = httpResult.data.LOWESTSERVICEID+'|'+httpResult.data.LOWESTSHIPCOST;
                    $scope.packshippackage = $scope.packshippackage;
                    $scope.packships = httpResult.data.SHIPS;
                    $scope.new_available_services = httpResult.data.NEW_AVAILABLE_SERVICES;
                    $scope.loading = false;

                    var valueToFind = "FEDEX_PTP_SECOND_DAY_ONE_RATE";
                    var foundIndex = $scope.new_available_services.includes(valueToFind);

                    if (foundIndex) {
                        $scope.fedEx_lowestFound = 1;
                    }else{
                        $scope.fedEx_lowestFound = 0
                    }

                    if(angular.isDefined(httpResult.data.LOWESTSERVICEID) && httpResult.data.LOWESTSERVICEID !== 'undefined'){
                        $scope.checkShipRate($scope.packshipssel);  
                    }

                });
            }
        };

 $scope.packshippackage = '';
$scope.packageOptions = [];

datacontext.getPackageDimensions({
    order_id: $scope.order_id,
    order_package_id: $scope.order_package_id

}).then(function(httpResult) {

    console.log('Package Dimensions:', httpResult);

    if (httpResult.data.success === true) {

        $scope.packshippackage = httpResult.data.PACKSHIPPACKAGE;
        $scope.length = httpResult.data.LENGTH;
        $scope.width = httpResult.data.WIDTH;
        $scope.height = httpResult.data.HEIGHT;
        $scope.weight = httpResult.data.WEIGHT;

        // Create the dropdown option
        $scope.packageOptions = [{
            value: $scope.packshippackage,
            label: $scope.length + ' x ' +
                   $scope.width + ' x ' +
                   $scope.height + ' inch (' +
                   $scope.weight + ' oz)'
        }];

        console.log('Package:', $scope.packshippackage);
        console.log('Package Options:', $scope.packageOptions);

        $scope.selectPackageType(
            $scope.packshippackage,
            $scope.order_id,
            1,
            $scope.is_prime
        );

    } else {
        log_error(httpResult.data.data);
    }

});



        $scope.createShipment = function(packshipssel,packshippackage,order_id,order_package_id,weight){

            console.log(packshipssel);
            console.log(packshippackage);
            console.log(order_id);
            console.log(order_package_id);
            console.log(weight);

            return datacontext.createShipment({packshipssel:packshipssel,packshippackage:packshippackage,order_id:order_id, order_package_id:order_package_id, weight:weight}).then(function(httpResult) {

                //log_success("Shipment Created");
                console.log("1234");
                console.log(httpResult);

                if(!httpResult.data.success){

                    log_error(httpResult.data.data);

                }else{

                    datacontext.getOrderPackageFull({order_id:order_id}).then(function(httpResult) {
                        console.log(httpResult);
                        $scope.order_packages = httpResult.data.data;
                        $scope.order_packages_cnt = httpResult.data.TOTAL;
                        $scope.order_package_order_status = httpResult.data.ORDER_STATUS;
                    });
                    log_success("Shipment Created");

                }

                $modalInstance.close();
            });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'onFEDEXGroundLabelModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'label_values', onFEDEXGroundLabelModalCtrl]);

    function onFEDEXGroundLabelModalCtrl(common, datacontext, $scope, $modalInstance, label_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId, 'success');
        var log_error = getLogFn(controllerId, 'error');
        var vm = this;

        console.log(label_values);

        $scope.order_id = label_values.order_id;
        $scope.is_prime = label_values.is_prime;
        $scope.order_package_id = label_values.order_package_id;
        $scope.isDisabled = true;
        $scope.fedEx_lowestFound = 0;
        $scope.ship_to_address_id = label_values.ship_to_address_id;
        $scope.ship_method_id = label_values.ship_method_id;
        $scope.fulfillment_warehouse_id = label_values.fulfillment_warehouse_id;
        $scope.customer_id = label_values.customer_id;
        $scope.label_ready = label_values.label_ready; 
        $scope.upd_pack_detail = label_values.upd_pack_detail;
        $scope.items_packed = label_values.items_packed;

        console.log($scope.fulfillment_warehouse_id);

        $scope.cancel = function() {
            $modalInstance.dismiss('cancel');
        };

        $scope.createShipment = function(width, height, length, weight, order_id, order_package_id, ship_to_address_id, ship_method_id, fulfillment_warehouse_id, customer_id, label_ready, upd_pack_detail, pickpack_slip_id, items_packed){
            console.log(width);
            console.log(height);
            console.log(length);
            console.log(order_id);
            console.log(order_package_id);
            console.log(weight);
            console.log(fulfillment_warehouse_id);

            var shipLabelRequest = {
                order_id: order_id,
                order_package_id: order_package_id,
                width: width,
                height: height,
                length: length,
                weight: weight,
                ship_to_address_id: ship_to_address_id,
                ship_method_id: ship_method_id,
                fulfillment_warehouse_id: fulfillment_warehouse_id,
                customer_id: customer_id,
                label_ready: label_ready,
                upd_pack_detail: $scope.upd_pack_detail,
                order_ids: ""
            };

            var fulfillment_status_id = "";
            var order_id = label_values.order_id;
            var pickpack_slip_id = pickpack_slip_id;
            var items_packed = items_packed;

            console.log(items_packed);

            var arrayLength = items_packed.length;
            // check if last item and mark slip as done

            // Loop items and mark as packed
            var qty_ordered = 0;
            var qty_packed = 0;
            var update_success = true;

            console.log(shipLabelRequest);

            datacontext.createShipLabel(shipLabelRequest).success(function(httpResult) {

                console.log(shipLabelRequest);
                console.log(httpResult);

                if (httpResult.success === true) { 

                    // Push to page
                    console.log(httpResult);
                    console.log($scope.order_package_id);

                    // UPDATE QTY PICKED AND TRACKING NUMBER
                    for (var i = 0; i < arrayLength; i++) {
                        // add pickpack/order id to item array
                        items_packed[i].pickpack_slip_id = pickpack_slip_id;
                        items_packed[i].order_id = order_id;
                        items_packed[i].order_package_id = $scope.order_package_id;
                        items_packed[i].package_item_id = items_packed[i].package_item_id;
                        // sum up ordered
                        qty_ordered = items_packed[i].to_ship_qty;
                        // sum up packed
                        items_packed[i].qty_packed = items_packed[i].to_ship_qty;
                        items_packed[i].order_package_id = $scope.order_package_id;
                        items_packed[i].only_packing = 1;
                        items_packed[i].from_od_page = 1;
                        items_packed[i].upd_pack_detail = httpResult.UPD_PACK_DETAIL;
                        // Update QTY Packed
                        datacontext.update_pack_list(items_packed[i]).success(function(rSPQ) {
                            // Returns list of Pick / Pack slips
                            if (rSPQ.SUCCESS === true) {
                                console.log('updated');
                            } else {
                                console.log('not updated');
                            }
                        });
                    }

                    window.location.reload();

                } else {

                    console.log(httpResult);

                    if(angular.isDefined(httpResult.data)) {
                      $scope.label_error = httpResult.data;
                      log_error(httpResult.data);
                    }
                    //window.location.reload();

                }
            });

            return false;
        }

    }
})();

(function() {
    'use strict';
    var controllerId = 'onRePrintWfpFtpModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','print_values', onRePrintWfpFtpModalCtrl]);

    function onRePrintWfpFtpModalCtrl(common, datacontext, $scope, $modalInstance, print_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.button = 'PRINT';
        $scope.buttonSuccess = 1;
        $scope.printer_name = '';

        $scope.layout = print_values.layout;
        $scope.order_package_id = print_values.order_package_id;
        $scope.to_ship_qty = print_values.to_ship_qty;
        $scope.product_id = print_values.product_id;
        $scope.category_id = print_values.category_id;
        $scope.master_product_id = print_values.master_product_id;
        $scope.order_id = print_values.order_id;
        $scope.pickpack_slip_id = print_values.pickpack_slip_id;
        $scope.error_message = print_values.error_message;
        $scope.width = print_values.width;
        $scope.height = print_values.height;
        $scope.user_orientation_id = print_values.user_orientation_id;
        $scope.wfp_image_s3_status = print_values.wfp_image_s3_status;
        $scope.printer = print_values.printer;
        $scope.pod_dimension_id = print_values.pod_dimension_id;
        $scope.hi_res_image_id = print_values.hi_res_image_id;
        //$scope.printer = 4;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
        $scope.swapDimensions = function(product_id, width, height){
          console.log(product_id+':'+width+':'+height);

          var itemDataSwap = {
                product_id: product_id,
                width: width,
                height: height};
          datacontext.swap_dimensions(itemDataSwap).success(function(response) {
              log_success("Image width and height swapped!");
              //submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
              // close it
              //$modalInstance.close();
          });
        };
        $scope.submit_reprint_wfp = function(layout, order_package_id, to_ship_qty, product_id, category_id, pod_dimension_id, master_product_id, order_id,pickpack_slip_id,printer,user_orientation_id,width,height,hi_res_image_id) {
          console.log(layout);
          console.log(product_id);
          console.log(master_product_id);
          console.log(category_id);
          console.log('printer'+printer);

          if(printer == 20){
            $scope.printer_name = 'EPSON P20';
          }else if(printer == 60){
            $scope.printer_name = 'EPSON S60';
          }else if(printer == 82){
            $scope.printer_name = 'HP 8200';
          }else if(printer == 1640){
            $scope.printer_name = 'Canon Colorado';
          }

          if(master_product_id != 0){
            master_product_id = master_product_id;
          }
          if(!angular.isDefined(layout) || printer == 0 || printer === undefined){
            log_error("Please select Printer");
            $scope.error_message = "Please select Printer";
          }else if(!angular.isDefined(layout) ){
            log_error("Please select Layout");

          }else{

            $scope.button = 'Printing';
            $scope.buttonSuccess = 2;

            if(layout == 1 || layout == true){
              if(master_product_id != 0){
                log_success("Image pushed to regular Printer " +$scope.printer_name);
                datacontext.print_wfp_regular(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
                    // close it
                    $modalInstance.close();
                });
              }else{
                log_success("Image pushed to regular Printer " +$scope.printer_name);
                datacontext.print_wfp_regular(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to regular Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
                    // close it
                    $modalInstance.close();
                });
              }
            } else {
              if(master_product_id != 0){
                log_success("Image pushed to rotate Printer " +$scope.printer_name);
                datacontext.print_wfp_rotate(master_product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
                    // close it
                    $modalInstance.close();
                });
              }else{
                log_success("Image pushed to rotate Printer " +$scope.printer_name);
                datacontext.print_wfp_rotate(product_id,printer,user_orientation_id,width,height,product_id,category_id,pod_dimension_id,hi_res_image_id).success(function(response) {
                    log_success("Image pushed to rotate Printer " +$scope.printer_name);
                    submit_pick(order_package_id,to_ship_qty,product_id,order_id,pickpack_slip_id);
                    /// close it
                    $modalInstance.close();
                });
              }
            }
          }

        };

        function submit_pick(order_package_id,picked_qty,product_id,order_id,pickpack_slip_id) {
        	console.log(order_package_id);
        	console.log(picked_qty);

        	var itemData = {
                pickpack_slip_id: pickpack_slip_id,
                qty_picked: picked_qty,
                is_picked: 1,
                product_id: product_id,
                order_id:order_id,
                order_package_id: order_package_id,
                frompick: 1
            };


            //vm.submitted = true;

            	// Update Pick Item
                datacontext.update_pick_list_wfp(itemData).success(function(httpResult) {
                        // Returns list of Pick / Pack slips
                        if (httpResult.success === true) {
                        	//console.log("true");
                        	location.reload();
                        } else {
                          //console.log("false");
                        }
                    });

        }

    }
})();
(function() {
    'use strict';
    var controllerId = 'onRePickModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','repick_print', 'user_name', onRePickModalCtrl]);

    function onRePickModalCtrl(common, datacontext, $scope, $modalInstance, repick_print, user_name) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.repick_print = repick_print;
        $scope.user_name = user_name;
        $scope.pack_date = new Date();
        for(var i=0; i < repick_print.length; i++){
            console.log(repick_print[i].order_id);
            $scope.order_id = repick_print[i].order_id;
            $scope.pickpack_slip_id = repick_print[i].pickpack_slip_id;
            $scope.ship_by = repick_print[i].mp_ship_latest_by;

        }
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'editPackageModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','orderpackage', editPackageModalCtrl]);

    function editPackageModalCtrl(common, datacontext, $scope, $modalInstance, orderpackage) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        $scope.submitted = 0;

        // Pushes input to scope
        $scope.orderpackage = orderpackage;
        console.log(orderpackage);
        var old_ship_method_id = orderpackage.ship_method_id;
        // set ship date to now if null
        if ($scope.orderpackage.shipped_on === '') {
            $scope.orderpackage.shipped_on = moment().format();
            console.log($scope.orderpackage.shipped_on);
        }

        var edit_package_data = {
            edit_package:1,
            ship_method_id:old_ship_method_id
        };

        // Ship Methods
        /*datacontext.get_ship_methods().then(function(response) {
          console.log(444);
          console.log(old_ship_method_id);
            $scope.ship_methods = response.data.data;
        });*/

        datacontext.get_ship_methods_v1(old_ship_method_id).then(function(response) {
          console.log(444);
          console.log(old_ship_method_id);
            $scope.ship_methods = response.data.data;
        });

        datacontext.get_pickpack_types_sort_v1().then(function(httpResult) {
          $scope.pickpack_types = httpResult.data.data;
        });


        datacontext.get_order_package_status().then(function(response) {
            $scope.order_package_status = response.data.data;
        });

        $scope.weights = [{"weight":"1 pound","weight_value":1},{"weight":"2 pounds","weight_value":2},{"weight":"3 pounds","weight_value":3},{"weight":"4 pounds","weight_value":4},{"weight":"5 pounds","weight_value":5},{"weight":"6 pounds","weight_value":6},{"weight":"7 pounds","weight_value":7},{"weight":"8 pounds","weight_value":8},{"weight":"9 pounds","weight_value":9},{"weight":"10 pounds","weight_value":10}];
        var  package_data = {};
        package_data.order_package_id = $scope.orderpackage.order_package_id;

        /*datacontext.get_weight_override(package_data).then(function(response){
            $scope.orderpackage.weight_override  = response.data.data;
            
        });*/

        //console.log("Packege_weight_override" + $scope.package_weight_override  );

        $scope.reset_order_package = function () {
            // Delete Package & Reset to Pick
            var deleted_data = {
                order_package_id :$scope.orderpackage.order_package_id,
                order_id:$scope.orderpackage.order_id
            };

            return datacontext.reset_order_package(deleted_data).then(function(httpResult) {
                $modalInstance.close($scope.orderpackage.order_package_id);
            });
        };

        $scope.isPickClick = function (idx) {
            if ( $scope.orderpackage.items[idx].is_picked === 0 ) {
                $scope.orderpackage.items[idx].is_picked = 0;
            } else {
                $scope.orderpackage.items[idx].is_picked = 1;
            }
        };

        $scope.isPackClick = function (idx) {
            if ( $scope.orderpackage.items[idx].is_packed === 0 ) {
                $scope.orderpackage.items[idx].is_packed = 0;
            } else {
                $scope.orderpackage.items[idx].is_packed = 1;
            }
        };

        $scope.ok = function () {

            $scope.submitted = 1;

            // set variables
            var formData = {};
            formData.order_package_id = $scope.orderpackage.order_package_id;
            formData.order_package_status_id = $scope.orderpackage.order_package_status_id;
            // get pickslip id
            formData.order_id = $scope.orderpackage.order_id;
            formData.ship_method_id = $scope.orderpackage.ship_method_id;
            formData.tracking_code = $scope.orderpackage.tracking_code;
            formData.pickpack_type_id = $scope.orderpackage.pickpack_type_id;

            if($scope.orderpackage.weight_override > 0  && $scope.orderpackage.weight_override != undefined ){
                formData.weight_override = $scope.orderpackage.weight_override;
            }
            if ( formData.tracking_code !== '') {
                // prevent false shipped_on when updating other data
                formData.shipped_on = $scope.orderpackage.shipped_on;

                // auto mark ship if status <> canceled
                if ($scope.orderpackage.order_package_status_id < 4) {
                    formData.order_package_status_id = 4;
                }
            }

            if ( $scope.orderpackage.bypass_marketplace_update === '') {
                formData.bypass_marketplace_update = 0;
            } else {
                formData.bypass_marketplace_update = 1;
            }

            if ( $scope.orderpackage.is_ship_priority === '') {
                formData.is_ship_priority = 0;
            } else {
                formData.is_ship_priority = 1;
            }
            formData.from_od_page = 1;
            formData.abs_override_no = 1;
            console.log(formData);
            console.log(orderpackage);
            if(old_ship_method_id === 12 && formData.ship_method_id !== 4 && formData.ship_method_id !== 12){
              log_error("Premium orders must ship with expedited services.");
            }else{
              // update package
              return datacontext.updateOrderPackage(formData).then(function() {
                  // todo add try catch

                  // loop items flag for update
                  angular.forEach($scope.orderpackage.items, function (item) {
                      // set order item variables


                      var formItemData = {};
                      formItemData.order_id = $scope.orderpackage.order_id;
                      formItemData.package_item_id = item.package_item_id;

                      formItemData.picked_qty = item.picked_qty;
                      formItemData.packed_qty = item.packed_qty;
                      formItemData.to_ship_qty = item.to_ship_qty;
                      formItemData.qty_original = item.qty_original;

                      if ( item.picked_qty > 0) {
                          formItemData.is_picked = 1;
                      } else {
                          formItemData.is_picked = 0;
                      }
                      if ( item.packed_qty > 0 ) {
                          formItemData.is_packed = 1;
                      } else {
                          formItemData.is_packed = 0;
                      }

                      console.log(formItemData);

                      // Update Order items
                      return datacontext.updateOrderPackageItem(formItemData).then(function(httpResult) {
                          // Refresh Order item data
                      });
                  });

                  $scope.$broadcast('refreshAuditLog', 'refresh');
                  $modalInstance.close($scope.orderpackage.order_package_id);

                  // update order fullfillment status
                  // and if order should be closed
                  /*
                  return datacontext.update_order_fulfillment_status(formData).then(function(httpResult) {
                      $scope.$broadcast('refreshAuditLog', 'refresh');
                      $modalInstance.close($scope.orderpackage.order_package_id);
                      // todo add audit to update_order_fulfillment_status
                  });
                  */
              });
              $modalInstance.close($scope.fulfill);
            }


        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();
